import { REQUEST_COUPONS, RECEIVE_COUPONS, FAILURE_COUPONS } from './constants';
import _ from 'lodash';
import { CALL_API } from '../../middlewares/api';

const shouldFetchPartnerCoupons = (state, idPartner) => {
    const coupons = state.coupon.coupons[idPartner] ? state.coupon.coupons[idPartner] : [];
    const fetching = state.coupon.fetching;

    if (!idPartner || fetching) {
        /* TODO : !idPartner est peut etre à changer et
                plutot que de ne pas fetch plutot throw une exception
                 ou autre
                 */
        return false;
    } else if (_.isEmpty(coupons)) {
        return true;
    } else {
        return false;
    }
};

export const fetchPartnerCouponsIfNeeded = idPartner => {
    return {
        [CALL_API]: {
            endpoint: `/partner/${idPartner}/coupon`,
            types: [REQUEST_COUPONS, RECEIVE_COUPONS, FAILURE_COUPONS],
            shouldCallAPI: state => shouldFetchPartnerCoupons(state, idPartner),
            payload: { idPartner }
        }
    };
};



// WEBPACK FOOTER //
// ./src/services/coupon/actions.js